// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34mvH","inner":"styles_inner__1davH","right":"styles_right__1uX2T","close":"styles_close__3c469","footer":"styles_footer__3fPz4"};